var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.92 35.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.41,16.29,7.09,23.86a.9.9,0,0,1-.69.32H6.35a.91.91,0,0,1-.7-.4L.15,15.6A.92.92,0,0,1,.4,14.34a.89.89,0,0,1,1.25.25l3.78,5.63A17.71,17.71,0,0,1,7.88,9.07,18.6,18.6,0,0,1,19.48.48,17.63,17.63,0,0,1,36.78,6a.9.9,0,1,1-1.35,1.19A15.83,15.83,0,0,0,19.9,2.24,16.78,16.78,0,0,0,9.43,10a15.89,15.89,0,0,0-2.1,10.76L12,15.13a.9.9,0,0,1,1.38,1.16ZM46.77,22l-5.5-8.18a.88.88,0,0,0-.7-.4.86.86,0,0,0-.74.32l-6.32,7.57a.9.9,0,1,0,1.38,1.15l4.68-5.6A16.31,16.31,0,0,1,27.19,33.1,15.8,15.8,0,0,1,12.4,29a.91.91,0,0,0-1.27,1.29,17.59,17.59,0,0,0,12.37,5.1A17.91,17.91,0,0,0,41.4,17.27L45.27,23a.9.9,0,0,0,.75.4.85.85,0,0,0,.5-.16A.91.91,0,0,0,46.77,22ZM25,18.15l4.41,6.08H26.8l-4.07-5.84h-.39v5.84H20.19V10h2.52A6.29,6.29,0,0,1,26.79,11a3.91,3.91,0,0,1,1.38,3.12,4.06,4.06,0,0,1-.86,2.61A3.91,3.91,0,0,1,25,18.15Zm1.06-4c0-1.46-1-2.19-3-2.19h-.76v4.53H23Q26.08,16.52,26.08,14.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.3afda732012f834e12311827b4f5f70e.svg";
export { ForwardRef as ReactComponent };